import { render, staticRenderFns } from "./warninfo.vue?vue&type=template&id=3fe0a3c2&scoped=true&"
import script from "./warninfo.vue?vue&type=script&lang=js&"
export * from "./warninfo.vue?vue&type=script&lang=js&"
import style0 from "./warninfo.vue?vue&type=style&index=0&id=3fe0a3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe0a3c2",
  null
  
)

export default component.exports